import { memo, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PauseOutlined } from '@material-ui/icons'

import { RecordingStatus, RecordingType } from '@tabeeb/enums'
import { recordingActions, recordingSelectors } from '@tabeeb/modules/recording'
import { getRecordingTypeDialogResult } from '@tabeeb/modules/whiteboard/selectors'

import ToolbarButton from '../ToolbarButton'

const PauseRecordingButton = () => {
  const dispatch = useDispatch()

  const recordingStatus = useSelector(recordingSelectors.getRecordingStatus)
  const recordingType = useSelector(getRecordingTypeDialogResult)

  const onClick = useCallback(() => {
    dispatch(recordingActions.onRecordingPausing())
  }, [dispatch])

  const isDisabled = useMemo(() => {
    switch (recordingType) {
      case RecordingType.cloud:
        return recordingStatus !== RecordingStatus.started
      case RecordingType.local:
      default:
        return false
    }
  }, [recordingStatus, recordingType])

  return (
    <ToolbarButton
      color='error'
      Icon={PauseOutlined}
      display={[RecordingStatus.starting, RecordingStatus.started].includes(recordingStatus)}
      disabled={isDisabled}
      title='Pause recording'
      onClick={onClick}
    />
  )
}

export default memo(PauseRecordingButton)
